var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLgvBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9004 0.101562H1.15263C0.519294 0.101562 -0.000976562 0.621834 -0.000976562 1.25517V7.92589C-0.000976562 8.58129 0.519294 9.10156 1.15263 9.10156H14.9013C15.5567 9.10156 16.0549 8.58129 16.0549 7.92589L16.054 1.25426C16.054 0.620929 15.5567 0.101562 14.9004 0.101562ZM14.1549 8.1512C14.1549 8.30931 14.0189 8.49039 13.8157 8.49039H2.26022C2.07914 8.49039 1.92103 8.33228 1.92103 8.1512V1.05129C1.92103 0.870215 2.05706 0.689129 2.26022 0.689129H13.8376C14.0187 0.689129 14.1768 0.84724 14.1768 1.05129V8.1512H14.1549Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8182 2.38476H16.7555V6.83922H17.8182C17.9763 6.83922 18.0893 6.70319 18.0893 6.56805V2.6339C18.0893 2.49788 17.9763 2.38476 17.8182 2.38476Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.59969 1.39025H4.79294V7.78985H2.59969V1.39025Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49429 1.39025H7.68753V7.78985H5.49429V1.39025Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36591 1.39025H10.5821V7.78985H8.36591V1.39025Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2824 1.39025H13.4756V7.78985H11.2824V1.39025Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLgvBattery);
export default __webpack_public_path__ + "static/media/LGVBattery.583f4429e7e1309257ac909b4062adec.svg";
export { ForwardRef as ReactComponent };